export default __webpack_public_path__ + "static/media/megachlor-manual.7425a7ac.pdf";